import React from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useFormName from '../../../../../../Hooks/useFormName';
import TopFieldContent from '../TopFieldContent';
import ErrorMessage from '../ErrorMessage';
import InputWrapper from '../InputWrapper/InputWrapper';

export interface BaseFieldProps {
	name: string;
	label?: string;
	isRequired?: boolean;
	className?: string;
	placeholder?: string;
	portal?: boolean;
	disabled?: boolean;
	isWrapped?: boolean;
	style?: React.CSSProperties;
	onChange?: (value: any) => void;
}

interface Props extends BaseFieldProps {
	children: React.ReactElement;
}

const BaseField: React.FC<Props> = ({
	name,
	label,
	isRequired,
	className,
	children,
	placeholder,
	portal,
	disabled,
	isWrapped,
	style,
	onChange,
}) => {
	const { fieldName } = useFormName({ name });
	const { control } = useFormContext();
	const {
		field,
		fieldState: { error },
	} = useController({
		control,
		name: fieldName || '',
	});

	const handleChange = (value: any) => {
		field.onChange(value);
		onChange?.(value);
	};

	// @ts-ignore
	const errorMessage = (error?.message || error?.value?.message) ?? undefined;

	const component = (
		<div className={className}>
			{label && <TopFieldContent label={label} isRequired={isRequired} />}
			{React.cloneElement(children, {
				...children.props,
				value: field.value,
				onChange: handleChange,
				portal: portal,
				error: error,
				placeholder: placeholder,
				disabled: disabled,
				hasError: Boolean(error?.message),
				style: style,
			})}
			{errorMessage && <ErrorMessage tx={errorMessage} />}
		</div>
	);

	if (isWrapped) {
		return <InputWrapper>{component}</InputWrapper>;
	}

	return component;
};

export default BaseField;
